import { ACTIONS } from 'redux-api-call';
import { combineEpics, ofType } from 'redux-observable';
import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';

import { UPDATE_PASSWORD_API_ID } from '../../apiCalls/adminUsers/password';
import { UPDATE_USER_API_ID } from '../../apiCalls/adminUsers/edit';
import routerHistory from '../../routerHistory';

const handleUpdateUserSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(UPDATE_USER_API_ID))),
    map(action => {
      routerHistory.goBack();
    })
  );

const handleUpdatePasswordSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(UPDATE_PASSWORD_API_ID))),
    map(action => {
      routerHistory.goBack();
    })
  );

export default combineEpics(
  handleUpdateUserSuccess,
  handleUpdatePasswordSuccess
);
